import { createApp } from 'vue';
import { GoogleMap, Marker, AdvancedMarker, InfoWindow } from "vue3-google-map";
import { vMask } from "./input-mask";
import MaskedInput from "./MaskedInput";
import AnimatedNumber from "../components/AnimatedNumber.vue";
import { mqPlugin } from "./breakpoints";
import clickOutside from '../global/directives/clickoutside';
import { googleMapsPlugin } from '../plugins/google-maps';

class VueComponentRegistery {
	constructor() {
		this.components = {};

		document.addEventListener("DOMContentLoaded", () => {
			this.initAll();
		});
	}

	register(name, vueComponent, vueStore) {
		this.components[name] = {
			component: vueComponent,
			store: vueStore
		};
	}

	initAll() {
		Object.keys(this.components).forEach(name => {
			let store = this.components[name].store;
			let component = this.components[name].component;
			[...document.querySelectorAll(name)].forEach(elem => {
				// Extract props from HTML attributes, filtering out system attributes
				const props = {};
				const systemAttributes = [
					'id', 'class', 'style', 'title', 'lang', 'dir', 'tabindex',
					'data-component', 'data-v-', 'v-', 'ref', 'key',
					'aria-', 'role', 'accesskey', 'contenteditable', 'draggable',
					'hidden', 'spellcheck', 'translate', 'xmlns'
				];
				
				Array.from(elem.attributes).forEach(attr => {
					// Skip system attributes and data attributes that shouldn't be props
					const shouldSkip = systemAttributes.some(sysAttr => {
						return attr.name === sysAttr || 
							   attr.name.startsWith(sysAttr) ||
							   (sysAttr.endsWith('-') && attr.name.startsWith(sysAttr));
					});
					
					if (shouldSkip) {
						return;
					}
					
					// Convert kebab-case to camelCase for Vue props
					const propName = attr.name.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
					props[propName] = attr.value;
				});
				
				const app = createApp(component, props);
				
				app.use(mqPlugin);
				app.use(googleMapsPlugin);
				
				app.component('GoogleMap', GoogleMap);
				app.component('Marker', Marker);
				app.component('AdvancedMarker', AdvancedMarker);
				app.component('InfoWindow', InfoWindow);
				app.component('MaskedInput', MaskedInput);
				app.component('masked-input', MaskedInput);
				app.component('AnimatedNumber', AnimatedNumber);
				
				app.directive('mask', vMask);
				app.directive('click-outside', clickOutside);
				
				if (store) app.use(store);
				
				app.mount(elem);
			});
		});
	}
}

export default new VueComponentRegistery();
